import { Typography } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { EventType } from '../../../../../../constants'
import { useEventTracking } from '../../../../../../hooks'
import { FormMissingParametersEventData } from '../../../../../../types'

interface Props {
  invalidParameters: string[]
}

const MissingParameters = ({ invalidParameters }: Props) => {
  const { t } = useTranslation()
  const { track: trackEvent } = useEventTracking()

  useEffect(() => {
    const data: FormMissingParametersEventData = {
      formType: 'initial',
      isInitialValid: false,
      missingParameters: invalidParameters,
    }

    trackEvent(EventType.APPOINTMENT_FORM_MISSING_PARAMETERS, { data })
  }, [])

  return (
    <>
      <Typography variant="h2">{t('pages.appointment.messages.missingParameters')}</Typography>
      <ul>
        {invalidParameters.map((parameter) => (
          <li key={parameter}>{parameter}</li>
        ))}
      </ul>
    </>
  )
}

export { MissingParameters }
